<div class="padding-small bg-light-grey padding-left-large small">
  <div class="flex center">
    <span class="primary hover" (click)="onBack()">Media sharing</span>
    <i class="fa-solid fa-angle-right padding-right-small padding-left-small grey"></i>
    Link details
  </div>
</div>

<div class="padding-large m-padding">
  <div class="page-layout">
    <div class="flex column start">
      <h4>Link Detail</h4>

      <small class="grey margin-top">Generated link</small>
      <div class="flex margin-top-smallest margin-bottom bg-lightest-blue">
        <span class="unicode border border-blue padding-small">
          {{ getShareLink() }}
        </span>

        <i
          class="hover border fa-regular fa-copy small bg-light-grey flex center justify-center padding-small"
          matTooltip="Click to copy"
          (click)="copyShareLink()"
        ></i>
      </div>
    </div>

    <div class="flex column end">
      <button (click)="addProduct()">
        <i class="fa-solid fa-plus margin-right-small"></i>
        Add Product
      </button>
    </div>

    @if (mediaShareDetails.length) {
      <div class="flex start margin-top m-column">
        <aside class="media-share-menu border radius padding-small margin-right desktop-only">
          <bt-company-media-share-link-detail-menu
            [menu]="menu"
            [activeModelId]="activeModelId"
            (selectProduct)="scrollToProduct($event)"
          ></bt-company-media-share-link-detail-menu>
        </aside>

        <div class="flex-1 flex column gap m-full-width">
          @for (product of mediaShareDetails; track product.style.modelId) {
            <bt-company-media-share-link-detail-product
              class="media-share-product"
              [id]="getProductAnchorId(product)"
              [product]="product"
              (toggleProduct)="toggle($event)"
              (removeProduct)="removeProduct($event)"
              (removeColor)="removeColor(product, $event)"
              (openGallery)="viewGallery($event)"
            ></bt-company-media-share-link-detail-product>
          }
        </div>
      </div>
    } @else if (!loading) {
      <div class="bg-light-grey padding-largest margin-top flex column center">
        <i class="fa-solid fa-search fa-2xl margin-bottom grey"></i>
        <span>No shared media found</span>
      </div>
    }
  </div>
</div>

@if (loading) {
  <bt-loader></bt-loader>
}
